import { React, useEffect, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import {
	collection,
	doc,
	addDoc,
	onSnapshot,
	updateDoc,
} from "firebase/firestore";
import db from "../firebase";
import Cookies from "js-cookie";
import { Navigate, useNavigate } from "react-router-dom";
import { UserContext } from "./User";
import getBrowserFingerprint from "get-browser-fingerprint";
import DATA from "./Data";
import { ReactComponent as LagoonLogo } from "../assets/logo.svg";
import FingerprintJS from "@fingerprintjs/fingerprintjs-pro";
import { Firestore } from "firebase/firestore";
import PopUpMessage from "./PopUpMessage";

export default function SignUp1() {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();
	const navigate = useNavigate();
	const { user, setUser } = useContext(UserContext);
	const [users, setUsers] = useState([]);
	const [fingerprint, setFingeprint] = useState();
	const [popUp, setPopUp] = useState(false);
	const [popup, setPopup] = useState("");
	const [input, setInput] = useState("");
	const [accountCode, setAccountCode] = useState("");

	useEffect(() => {
		if (users.length === 0) {
			onSnapshot(collection(db, "users"), (snapshot) =>
				setUsers(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
			);
		} else {
			users.forEach((user) => {
				if (user.fingerprint === fingerprint) {
					Cookies.set("id", user.id);
					setUser(user);
					// return user;
				}
			});
		}
	}, [users]);

	useEffect(() => {
		if (!fingerprint) {
			const fpPromise = FingerprintJS.load({
				apiKey: "XjuHS179kM6xN4lfdR95",
			});
			fpPromise
				.then((fp) => fp.get())
				.then((result) => {
					setFingeprint(result.visitorId);
				});
		} else {
			console.log(fingerprint);
		}
	}, [fingerprint]);

	const closeModal = async () => {
		if (input === accountCode) {
			Cookies.set("id", user.id);
			const user_ref = doc(db, "users", user.id);
			await updateDoc(user_ref, {
				fingerprint: fingerprint,
			});
			navigate("/");
		} else {
			document.querySelector("#error").innerHTML =
				"Looks like your code is incorrect - please, try again!";
		}
	};

	const closeModal1 = () => {
		navigate("/");
	};

	useEffect(() => {
		console.log(accountCode);
		if (accountCode.length !== 0) {
			console.log(accountCode);
			// const user_ref = doc(db, "users", user.id);
			// updateDoc(user_ref, {
			// 	accountCode: accountCode,
			// });
			addDoc(collection(db, "sms"), {
				to: user.phone,
				body: `Thank you for confirming the phone number. Your code is ${accountCode}`,
			});
		}
	}, [accountCode]);

	const checkUser = async (data) => {
		setPopUp(true);
		setPopup("Sorry we can't find your account, please sign in!");

		users.forEach(async (user) => {
			if (user.phone === data.phone) {
				setUser(user);
				setAccountCode(
					Date.now()
						.toString()
						.substring(Date.now().toString().length - 4) +
						Math.floor(Math.random() * 100)
				);
				setPopup("Enter your activation code from the text message");
			}
		});
	};
	// return Cookies.get().id ? (
	// 	<Navigate to="/" />
	// ) : (
	return (
		<>
			<LagoonLogo className="lagoon-logo" />
			<h2 id="signin-header">Welcome back!</h2>
			<form id="signin-form">
				{/* <label htmlFor="firstName">First Name</label> */}
				<input
					{...register("phone", { required: "Your phone number is required" })}
					placeholder="Your Phone number"
				/>
				<p>{errors.phone?.message}</p>
				<button
					onClick={handleSubmit((data) => {
						checkUser(data);
						// reset();
					})}
					type="submit"
				>
					Retrieve account
				</button>
				<button class="no-button" onClick={() => navigate("/signup")}>
					Back to sign in page
				</button>
			</form>
			<PopUpMessage
				trigger={popUp}
				closeModal={user.id ? closeModal : closeModal1}
			>
				{
					<div>
						{user.id ? <h2>Please enter the code from text message</h2> : ""}
						<p>{popup}</p>
						{user.id ? (
							<input
								id="activation-input"
								name="validation"
								placeholder="Input your code here"
								onChange={(e) => setInput(e.target.value)}
							/>
						) : (
							""
						)}
						{user.id ? <p id="error"></p> : ""}
					</div>
				}
			</PopUpMessage>
		</>
	);
}
